import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-refresh-icon',
    templateUrl: './refresh-icon.component.html',
    styleUrls: ['./refresh-icon.component.scss']
})
export class RefreshIconComponent extends AbstractIcon {
    constructor() {
        super();
        this.height = 24;
        this.width = 24;
    }
}
